
/// <amd-module name="Search/Shared/Components/ResultsInfo/ResultsInfo" />
import * as React from "react";
import * as Resources from "Search/Shared/Resources";
import { Link } from "VSSUI/Link"
import { IResultsInfoProps } from "./ResultsInfo.Props";

export const ResultsInfo = (props: IResultsInfoProps) => {
    return (
        <div className="results-info flex-row flex-noshrink">
            <span className="info-message flex-grow" role="alert" aria-live="assertive">{props.infoMessage}</span>
            {
                props.showFeedbackLink && <span className="feedback-link flex-grow flex-shrink">
                    <Link href="#" onClick={ props.onFeedbackLinkInvoked} tooltipProps={{ text: props.stalenessMessage }}>
                        {Resources.DataRefreshInfoLabel}
                    </Link>
                </span>
            }
        </div>);
}
